import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBezierRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBezierRemove"><Path d="M15 11.25H9V12.75H15V11.25Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H9V5.25H15V3H21V9H18.75V15H21V21H15V18.75H8.75V21H3V15H5.25V9H3V3ZM9 6.75V9H6.75V15H8.75V17.25H15V15H17.25V9H15V6.75H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBezierRemove;
